<template lang="pug">
  b-container
    b-form-row.align-items-center.mt-3.mb-4
      b-col
        h4.mb-2 Personalización
        p.text-secondary.mb-4 Personaliza los mensajes que envía el Chat de tu tienda en línea como el mensaje de bienvenida, su nombre y otras variables.
    div(v-for="type in parsed_attributes", :key="type.value", v-if="type.attributes.length")
      b-link.text-reset(v-b-toggle="'type_' + type.value")
        h5 {{type.title}}
          chevron-down-icon.ml-1.icon-md
      b-collapse.mb-4(:id="'type_' + type.value", visible)
        b-row.mb-2
          b-col(md="6", v-for="account_attribute in type.attributes", :key="account_attribute.account_attribute_id")
            b-card
              p.mb-0 {{ account_attribute.title }}
              p.text-secondary {{ account_attribute.description }}
              
              div(v-if="account_attribute.message_type")
                b-row(v-if="account_attribute.message_type == 'message'")
                  b-col.mb-3(cols="12", v-for="(textLine, index) in splitText(account_attribute.value)", :key="index")
                    .messenger-text
                      .text {{ textLine }}

                b-row(v-else-if="account_attribute.message_type == 'button'")
                  b-col.mb-3(cols="12", v-for="(textLine, index) in splitText(account_attribute.value)",  :key="index")
                    .messenger-text
                      .text.text-help Mensaje que se envía en el siguiente botón
                      .message-button(variant="outline-primary") {{ account_attribute.value }}

                b-row(v-else-if="account_attribute.message_type == 'quick_reply'")
                  b-col.mb-3(cols="12", v-for="(textLine, index) in splitText(account_attribute.value)",  :key="index")
                    div.mb-3
                      .messenger-text
                        .text.text-help Mensaje que se envía en el siguiente botón
                    .quick-reply {{ account_attribute.value }}

              b-form-group(v-else-if="account_attribute.frontend_type == 'text_area'")
                b-form-textarea(placeholder="Valor de variable", v-model="account_attribute.value", @input="account_attribute.edited = true", rows="3", max-rows="8", no-resize)
              b-form-group(v-else-if="account_attribute.frontend_type == 'checkbox'")
                b-form-checkbox(switch, :checked="Boolean(account_attribute.value)", @change="account_attribute.value = $event; account_attribute.edited = true") {{ Boolean(account_attribute.value) ? 'Encendido' : 'Apagado' }}
              b-form-group(v-else-if="account_attribute.frontend_type == 'input_number'")
                number-input(inline, controls, center, placeholder="0", v-model="account_attribute.value", @change="account_attribute.edited = true")
              div(v-else-if="account_attribute.frontend_type == 'image'")
                input(type="file", accept="image/*", style="display:none;", :ref="'input_attr_' + account_attribute.account_attribute_id", @change="fileSelected($event, account_attribute)")
                b-img.mb-2(width="100", height="100", :src="account_attribute.value", @error="account_attribute.error = true", :blank="!account_attribute.value || account_attribute.error", blank-color="#ccc", rounded)
                div(v-if="!account_attribute.value")
                  b-link.text-primary.mr-3(@click="$refs['input_attr_' + account_attribute.account_attribute_id][0].click()") Subir imagen
                div(v-else)
                  b-link.text-primary.mr-3(@click="$refs['input_attr_' + account_attribute.account_attribute_id][0].click()") Cambiar imagen
                  b-link.text-danger(@click="fileSelected(null, account_attribute)") Quitar imagen
              b-form-group(v-else-if="account_attribute.frontend_type == 'input_password'")
                b-input-group
                  b-form-input(placeholder="Valor de variable", :type="!account_attribute.show ? 'password' : 'text'", v-model="account_attribute.value", @input="account_attribute.edited = true")
                  b-input-group-append
                    b-button(variant="secondary", @click="account_attribute.show = !account_attribute.show")
                      eye-off-icon.icon-sm(v-if="account_attribute.show")
                      eye-icon.icon-sm(v-else)
              b-form-group(v-else-if="account_attribute.frontend_type == 'input_text'")
                b-form-input(placeholder="Valor de variable", v-model="account_attribute.value", @input="account_attribute.edited = true")
              b-form-group(v-else, :description="account_attribute.parsed_type")
                b-form-textarea(placeholder="Valor de variable", v-model="account_attribute.value", @input="account_attribute.edited = true", max-rows="5", no-resize)
              b-form-row.mt-3
                b-col(cols="auto", v-if="account_attribute.message_type")
                  b-button(variant="info", size="sm", @click="editVariableModal = true; attributeEdit = account_attribute")
                    | Editar texto
                    edit-3-icon.icon-sm.ml-1
                b-col(cols="auto")
                  b-button(:variant="account_attribute.edited ? 'primary' : 'soft-secondary'", :disabled="!account_attribute.edited", size="sm", @click="updateAccountAttribute(account_attribute)") Guardar
    empty-message(v-if="!account_attributes.length", message="No hay variables disponibles")
    b-modal(v-model="editVariableModal", @hidden="modalIsHidden", ok-only, ok-title="Cerrar", ok-variant="secondary")
      b-container
        b-row
          b-col(cols="12", v-if="attributeEdit")
            b-form-group(label="Agrega el texto a continuación:")
              div(v-if="attributeEdit.message_type == 'message'")
                p.text-secondary Cada salto de línea se envía como un globo de texto independiente.
                div.mb-3(v-for="(line, line_index) in attributeMessageLines")
                  .d-flex.align-items-center.justify-content-between.mb-1
                    span Mensaje {{ line_index + 1 }}:
                    x-icon.icon-md.text-secondary.hover-danger.pointer(@click="attributeMessageLines.splice(line_index, 1)")
                  b-form-textarea(rows="2", max-rows="5", no-resize, v-model.trim="attributeMessageLines[line_index]", @input="attributeEdit.edited = true", placeholder="Escribe el mensaje...")
                b-button(variant="success", size="sm", @click="attributeMessageLines.push('')")
                  plus-icon.icon-sm.mr-1
                  span Agregar salto de línea
              b-form-textarea(v-else, rows="5", max-rows="10", no-resize, v-model="attributeEdit.value", @input="attributeEdit.edited = true")
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
const accountAttributeController = createNamespacedHelpers('account_attribute')

import { UploadFile } from '@/helpers/upload-file'

export default {
  data () {
    return {
      frontend_types: [
        {title:'Habilitar funcionalidades', value: 'checkbox'},
        {title:'Editar textos', value: 'input_text'},
        {title:'Editar números', value: 'input_number'},
        {title:'Contraseñas', value: 'input_password'},
        {title:'Correos electrónicos', value: 'input_email'},
        {title:'Editar textos largos', value: 'text_area'},
        {title:'Imágenes', value: 'image'},
        {title:'Colores', value: 'color'},
      ],
      attributeEdit: null,
      attributeMessageLines: [],
      editVariableModal: false,
      lineBreakText: 'Agrega  \\n  para dar un salto de linea en el mensaje:'
    }
  },
  computed: {
    ...accountAttributeController.mapState({
      account_attributes: state => state.account_attributes
    }),
    parsed_attributes () {
      return this.frontend_types.map(f => {
        f.attributes = this.account_attributes.filter(a => a.frontend_type == f.value)
        if (f.value == 'input_text') {
          f.attributes.sort((a, b) => {
            let hasA = a.message_type ? 1 : 0;
            let hasB = b.message_type ? 1 : 0;

            return hasB - hasA
          })
        }
        if(f.value == 'checkbox') {
          f.attributes.forEach(a => {
            a.value = !(!a.value || a.value === "0")
          })
        }
        return f
      })
    }
  },
  methods: {
    ...mapActions(['account_attribute/all', 'account_attribute/update', 'helpers/upload_file']),
    getAccountAttributes () {
      let self = this
      // this.showLoadingScreen()

      this['account_attribute/all']({
        account_id: self.$route.params.account_id,
        forceUpdate: true,
        callback: res => {
          self.hideLoadingScreen()
          if (res.error) {
            self.$message.error(res.error)
          } else {

          }
        }
      })
    },
    splitText(text) {
      return text.split(/\\n/gmi)
    },
    updateAccountAttribute (account_attribute) {
      var self = this

      this['account_attribute/update']({
        account_id: self.$route.params.account_id,
        ...account_attribute,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Variable actualizada')
            account_attribute.edited = false
          }
        }
      })
    },
    async fileSelected(event, account_attribute) {
      let file = event ? event.target.files[0] : null
      if (file) {
        try {
          let image = await UploadFile.call(this, file)
          account_attribute.value = image
        } catch (e) {
          this.$message.error(e.message)
          account_attribute.value = ''
        }
      } else {
        account_attribute.value = ''
      }

      account_attribute.edited = true
    },
    modalIsHidden () {
      if (this.attributeEdit.message_type == 'message') {
        this.attributeMessageLines = this.attributeMessageLines.filter(m => m.length)
        let message = this.attributeMessageLines.join('\\n')
        this.attributeEdit.value = message
      }

      this.attributeEdit=null;
      this.attributeMessageLines=[];
    }
  },
  mounted () {
    this.getAccountAttributes()
  },
  watch: {
    attributeEdit (newValue) {
      if (!newValue) return;
      if (newValue.message_type == 'message') {
        let lines = newValue.value.split('\\n')
        this.attributeMessageLines = lines;

        if (!this.attributeMessageLines.length)
          this.attributeMessageLines.push('')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
